import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Icon } from "@iconify/react";

interface MonetaryStatisticsCardProps {
  days?: number;
}

export function MonetaryStatisticsCard({ days = 365 }: MonetaryStatisticsCardProps) {
  const monetaryStats = [
    {
      title: "Avg. Purchase Value",
      subtitle: "$42.50",
      cardIcon: "solar:wad-of-money-line-duotone",
      badgeColor: "bg-teal-400/10",
      statusValue: "+5.2%",
      statusIcon: "solar:course-up-line-duotone",
    },
    {
      title: "Conversion Rate",
      subtitle: "12.4%",
      cardIcon: "solar:reorder-line-duotone",
      badgeColor: "bg-teal-400/10",
      statusValue: "+1.2%",
      statusIcon: "solar:course-up-line-duotone",
    },
    {
      title: "Total Revenue",
      subtitle: "$12,450.00",
      cardIcon: "solar:banknote-line-duotone",
      badgeColor: "bg-teal-400/10",
      statusValue: "+15.3%",
      statusIcon: "solar:course-up-line-duotone",
    },
    {
      title: "Paying Users",
      subtitle: "156",
      cardIcon: "solar:user-speak-rounded-line-duotone",
      badgeColor: "bg-teal-400/10",
      statusValue: "+8.4%",
      statusIcon: "solar:course-up-line-duotone",
    },
  ];

  return (
    <div className="px-4 lg:px-6 w-full">
      <Card className="p-0">
        <CardContent className="flex items-stretch w-full flex-nowrap px-0">
          {monetaryStats.map((item, index) => (
            <div
              key={index}
              className="flex-1 border-e border-border last:border-e-0"
            >
              <div className="p-6">
                <div className="flex flex-col gap-1">
                  <div className="flex justify-between items-start">
                    <h5 className="text-base font-medium text-muted-foreground">
                      {item.title}
                    </h5>
                    <div className="p-3 rounded-full outline outline-border text-primary">
                      <Icon icon={item.cardIcon} width={16} height={16} />
                    </div>
                  </div>
                  <div className="flex flex-col gap-1">
                    <h5 className="text-2xl font-semibold">{item.subtitle}</h5>
                    <div className="flex items-center gap-2">
                      <p className="text-xs text-muted-foreground">
                        Last {days} days
                      </p>
                      <Badge
                        className={`${item.badgeColor} text-muted-foreground`}
                      >
                        <div className="flex items-center gap-1">
                          {item.statusValue}
                          <Icon icon={item.statusIcon} width={14} height={14} />
                        </div>
                      </Badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
